import { useLocation } from 'react-router-dom';
import { Header } from '../Navigation/Header';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const location = useLocation();

  // Don't show header on auth pages
  const hideHeader = location.pathname === '/login' || location.pathname === '/signup';

  return (
    <>
      {!hideHeader && <Header />}
      {children}
    </>
  );
}
